import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="grain min-h-screen bg-[#121016] text-[#f4ede2]">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
